export function registerServiceWorker(): Promise<ServiceWorkerRegistration | void> {
  return new Promise((resolve, reject) => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/serviceWorker.js")
        .then((registration) => {
          console.log("Service worker registrado com sucesso:", registration);

          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (installingWorker) {
              installingWorker.onstatechange = () => {
                if (
                  installingWorker.state === "installed" &&
                  navigator.serviceWorker.controller
                ) {
                  console.log("Nova versão instalada. Solicitando ativação.");
                  installingWorker.postMessage({ type: "SKIP_WAITING" });
                }
              };
            }
          };

          resolve(registration);
        })
        .catch((error) => {
          console.error("Falha ao registrar o service worker:", error);
          reject(error);
        });
    } else {
      console.warn("Service workers não são suportados neste navegador.");
      resolve();
    }
  });
}
